import { useEffect, useState } from "react";

export default function ExitPopup() {

  const [show,setShow] = useState(false)
  const [email,setEmail] = useState("")
  const [status,setStatus] = useState("idle")

 useEffect(() => {

  const alreadyClosed = localStorage.getItem("popupClosed")

  if (alreadyClosed) return

  const handleMouseLeave = (e:any) => {

    if(e.clientY <= 0){
      setShow(true)
      document.removeEventListener("mouseout", handleMouseLeave)
    }

  }

  document.addEventListener("mouseout", handleMouseLeave)

  return () => {
    document.removeEventListener("mouseout", handleMouseLeave)
  }

},[])
  const subscribe = async (e:any)=>{

    e.preventDefault()

    setStatus("loading")

    try{

      const res = await fetch("https://api.brevo.com/v3/contacts",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "api-key":"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"
        },
        body:JSON.stringify({
          email: email,
          listIds:[5],
          updateEnabled:true
        })
      })

      if(res.ok){
        setStatus("success")
        setEmail("")
      }else{
        setStatus("error")
      }

    }catch{
      setStatus("error")
    }

  }

  if(!show) return null

  return(

    <div className="fixed inset-0 z-[200] bg-black/60 flex items-center justify-center p-6">

      <div className="bg-white rounded-2xl max-w-md w-full p-10 text-center relative">

        <button
       onClick={()=>{
  localStorage.setItem("popupClosed","true")
  setShow(false)
}}
        className="absolute top-4 right-4 text-xl"
        >
        ×
        </button>

        <h2 className="text-2xl font-semibold mb-3">
        Prima di andare via...
        </h2>

        <p className="text-gray-600 mb-6">
        Ricevi il <strong>10% di sconto</strong> sul primo trattamento.
        </p>

        <form onSubmit={subscribe} className="flex flex-col gap-3">

          <input
          type="email"
          placeholder="La tua email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
          required
          className="px-4 py-3 border rounded-lg"
          />

          <button
          type="submit"
          className="bg-black text-white py-3 rounded-lg"
          >
          {status==="loading" ? "..." : "Ottieni lo sconto"}
          </button>

        </form>

        {status==="success" && (
          <p className="text-green-600 mt-4">
          Controlla la tua email per il codice sconto
          </p>
        )}

      </div>

    </div>

  )

}